<template>
  <router-link
      v-if="item.to"
      :to="{ name: item.to }"
      class="nav-item"
      @click="handleClick"
      :class="active ? 'nav-item-active' : ''"
  >
    <img loading="lazy" :src="active?item.prefixActive:item.prefixDeActive" class="nav-icon" />
    <img
        v-if="item.suffix"
        loading="lazy"
        :src="item.suffix"
        class="nav-icon nav-icon-suffix"
    />
  </router-link>
  <div v-else

       class="nav-item"
       @click="handleClick"
       :class="active ? 'nav-item-active' : ''"
  >
    <img loading="lazy" :src="active?item.prefixActive:item.prefixDeActive" class="nav-icon" alt="binnenkort beschikbaar" title="binnenkort beschikbaar"/>
    <img
        v-if="item.suffix"
        loading="lazy"
        :src="item.suffix"
        class="nav-icon nav-icon-suffix"
    />
  </div>
</template>
<style>
.nav-item {
  color: inherit;
  text-decoration: none;
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: center; /* Center-align content horizontally */
  padding: 4px;
  gap: 8px;
}

.nav-label {
  flex: 1; /* Span the available space */
  margin-right: 8px; /* Add gap between label and suffix */
}

.nav-icon {
  width: 24px;
  height: 24px;
}

.nav-item-active {
  width: 70%;
  text-decoration: none;
  background: var(--Primary-dark-2, #080AED);
  border-radius: 8px;
  color: var(--Neutral-1, #fcfcfc);
}
.nav-icon-suffix {
  margin-left: auto; /* Push suffix image to the end */
}
</style>
<script lang="ts">
import {defineComponent, PropType} from "vue";

interface NavItemProps {
  id: number;
  title: string;
  prefixActive: string;
  suffix?: string;
  prefixDeActive: string;
  to?: string;
  action?: () => void;
}

export default defineComponent({
  name: "NavItem",
  methods: {
    handleClick() {
      if (this.item.action) {
        this.item.action();
      }
    },
  },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    item: {
      type: Object as PropType<NavItemProps>,
      required: true,
    },
  },
});
</script>